/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/
import { BaseService } from './base';

/**
 *
 */
export interface FolderItemDTO {
    id: string;
    parent: string;
    name: string;
}

export interface GroupAdminDTO {
    groupId: string;
    organizationId: string;
    name: string;
}

/**
 *
 */
export interface FolderDTO {
    id: string;
    organization: string;
    name: string;
    description: string;
    branches: FolderItemDTO[];
    items: FolderItemDTO[];
    public: boolean;
}

export interface FolderAssetDTO {
    id: string;
    name: string;
}

export class AssetFolderService extends BaseService {
    public folderCache?: Map<string, FolderDTO>;

    constructor() {
        super();
        this.folderCache = new Map<string, FolderDTO>();
    }

    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('Asset Folder Service Loaded');

            const folderRequest = this.getFolders();
            folderRequest.then((data) => {
                if (data.parsedBody) {
                    for (let i = 0; i < data.parsedBody?.length; i++) {
                        this.folderCache?.set(data.parsedBody[i].id, data.parsedBody[i]);
                    }
                }
                resolve('Loaded');
            });
        });
    }

    /**
     *
     * @returns
     */
    async getAssetsForFolders() {
        const response = await this.get<FolderAssetDTO[]>(this.url + '/api/' + this.orgid + '/folder/assets');
        return response;
    }

    async getFolders() {
        const response = await this.get<FolderDTO[]>(this.url + '/api/' + this.orgid + '/folder/list/');
        return response;
    }

    async getAll() {
        const response = await this.get<GroupAdminDTO[]>(this.url + '/api/admin/group/list');
        return response;
    }

    /**
     *
     * @param id
     * @returns
     */
    async getFolder(id: string) {
        const response = await this.get<FolderDTO>(this.url + '/api/' + this.orgid + '/folder/' + id);
        return response;
    }

    async save(data: FolderDTO) {
        const response = await this.post<FolderDTO>(this.url + '/api/' + this.orgid + '/folder', data);
        return response;
    }

    async update(data: FolderDTO) {
        const response = await this.put<FolderDTO>(this.url + '/api/' + this.orgid + '/folder', data);
        return response;
    }

    /**
     *
     * @param data
     * @returns
     */
    async deleteFolder(data: FolderDTO) {
        const response = await this.delete<FolderDTO>(this.url + '/api/' + this.orgid + '/folder/', data);
        return response;
    }
}
